<script setup lang="ts">
  import { IFormItem } from '../utils/interfaces';
  import { useClearCss } from '../hooks/useClearCss';

  const { clearCss } = useClearCss();

  interface ContactFormResultProps {
    formItem: IFormItem;
    showSuccess: boolean;
    showError: boolean;
  };

  defineProps<ContactFormResultProps>();
</script>

<template>
  <div class="form-result-container">
    <div
      v-show="showSuccess"
      v-html="clearCss(formItem.formSuccessMessage.html)"
      class="form-result-success"
      data-pw-form="result-success"
    />
    <div
      v-show="showError"
      v-html="clearCss(formItem.formFailureMessage.html)"
      class="form-result-error"
      data-pw-form="result-error"
    />
  </div>
</template>

<style lang="scss" scoped>

.form-result-container {
  margin-top: 4rem;
}

.form-result-success,
.form-result-error {
  padding: 15px 20px;
  border-radius: 8px;
  font-size: 16px;
  max-width: 600px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-result-success {
  background-color: #e6ffed;
  border: 1px solid #34c759;
  color: #2d572c;
}

.form-result-error {
  background-color: #ffe6e6;   
  border: 1px solid #ff3b30;
  color: #7a0b0b;       
}
</style>